import { Injectable } from '@angular/core';
import { ToastController } from 'ionic-angular';

@Injectable()
export class ToastControllerService {
  constructor(
    public toastCtrl: ToastController,
  ) { }

  presentToast(alertData, elementToFocus = null) {
    if (alertData != null) {
      let toast = this.toastCtrl.create({
        message: alertData.message,
        position: 'top',
        showCloseButton: true,
        closeButtonText: 'X',
        cssClass: alertData.type + ' alertBox'
      });
      toast.present();
      if(elementToFocus != null){
        toast.onDidDismiss(() => {
          let elm = document.getElementById(elementToFocus);
          if(elm)
            elm.focus();
        });
      }
      return toast;
    }
  }
}


// WEBPACK FOOTER //
// ./src/providers/toast-controller.service.ts